<app-nav-pages></app-nav-pages>

<section
  class="hero-section d-flex justify-content-center align-items-center csr-hero"
>
  <div class="overlay"></div>
  <div class="hero-text text-center d-flex align-items-center flex-column">
    <h2>
      Grooming the next <br />
      Generation's Change Makers.
    </h2>
  </div>
</section>

<section>
  <div class="brand_container d-flex gap-3 f-c">
    <div class="statement d-flex flex-column wo-100">
      <h2 class="reach_out_zumera z-3 position-relative">
        The Future Change Makers
      </h2>
    </div>

    <div class="brand-text container wo-100">
      <p class="z-3 position-relative">
        We strongly believe that no brand or organization can truly succeed
        without the support of the community in which it exists. Our success as
        an organization is deeply tied to the growth and well-being of the
        communities we serve. By working together to pursue shared goals, we can
        achieve meaningful development that benefits both us and our community.
      </p>

      <p class="z-3 position-relative">
        We are passionate about building communities that recognize and
        celebrate the greatness within every individual, including those who are
        often overlooked, rejected, or underprivileged. We believe everyone has
        the potential to become a change maker and contribute to their community
        and our continent.
      </p>

      <p class="z-3 position-relative">
        Our goal is to leave a lasting impact—equipping the next generation with
        the tools and opportunities they need to continue transforming their
        communities long after the current generation has played its part.
      </p>
    </div>
  </div>
</section>

<section>
  <h2 class="text-center">REACH-OUT ZUMERA 2023</h2>
  <div class="brand_container d-flex gap-3 f-c">
    <div class="statement d-flex flex-column wo-100">
      <h2 class="reach_out_zumera z-3 position-relative">
        The Unsung Heroes Of Resilience
      </h2>
    </div>

    <div class="brand-text container wo-100">
      <p>
        The 2023 Reach-Out Event celebrated the unsung heroes of our community:
        widows. These remarkable women embody resilience and strength as they
        raise the next generation of change makers.
      </p>

      <p>
        Through an intimate empowerment program, we created unforgettable
        moments, forged meaningful connections, and renewed our commitment to
        inspiring hope for those who are often overlooked.
      </p>
    </div>
  </div>
</section>

<section class="container">
  <h2 class="text-center">Pictures from ReachOut Zumera 2023.</h2>
  <hr />
</section>

<section class="splide" aria-label="interior design">
  <div class="splide__track">
    <ul class="splide__list">
      <li class="splide__slide">
        <div class="d-flex flex-column justify-content-center gap-3">
          <div class="slide_img w-100">
            <img src="assets/imgs/RO23_11.jpg" class="img-fluid" />
          </div>
        </div>
      </li>

      <li class="splide__slide">
        <div class="d-flex flex-column justify-content-center gap-3">
          <div class="slide_img w-100">
            <img src="assets/imgs/RO23_3.jpg" class="img-fluid" />
          </div>
        </div>
      </li>

      <li id="test" class="splide__slide" #test>
        <div class="d-flex flex-column justify-content-center gap-3">
          <div class="slide_img w-100">
            <img src="assets/imgs/RO23_5.jpg" class="img-fluid" />
          </div>
        </div>
      </li>

      <li class="splide__slide">
        <div class="d-flex flex-column justify-content-center gap-3">
          <div class="slide_img w-100">
            <img src="assets/imgs/RO23_2.jpg" class="img-fluid" />
          </div>
        </div>
      </li>

      <li class="splide__slide">
        <div class="d-flex flex-column justify-content-center gap-3">
          <div class="slide_img w-100">
            <img src="assets/imgs/RO23_1.jpg" class="img-fluid" />
          </div>
        </div>
      </li>

      <li class="splide__slide">
        <div class="d-flex flex-column justify-content-center gap-3">
          <div class="slide_img w-100">
            <img src="assets/imgs/RO23_6.jpg" class="img-fluid" />
          </div>
        </div>
      </li>
      <li class="splide__slide">
        <div class="d-flex flex-column justify-content-center gap-3">
          <div class="slide_img w-100">
            <img src="assets/imgs/RO23_9.jpg" class="img-fluid" />
          </div>
        </div>
      </li>
      <li class="splide__slide">
        <div class="d-flex flex-column justify-content-center gap-3">
          <div class="slide_img w-100">
            <img src="assets/imgs/RO23_10.jpg" class="img-fluid" />
          </div>
        </div>
      </li>
    </ul>
  </div>
</section>
<section class="mt-5 pt-5">
  <h2 class="text-center">REACH-OUT ZUMERA 2022</h2>
  <div class="brand_container d-flex gap-3 f-c">
    <div class="statement d-flex flex-column wo-100">
      <h2 class="reach_out_zumera z-3 position-relative">Embracing Hope</h2>
    </div>

    <div class="brand-text container wo-100">
      <p>
        Zumera’s visit to Oghosa Orphanage was a powerful expression of our
        dedication to community growth.
      </p>

      <p>
        Our time with the children was a testament to our belief in holistic
        community development—fostering hope, unity, and a stronger, more
        connected society.
      </p>

      <p>
        We are committed to creating a brighter future, one community at a time.
      </p>
    </div>
  </div>
</section>

<section class="container">
  <h2 class="text-center">Pictures from ReachOut Zumera 2022.</h2>
  <hr />
</section>

<app-reach-out-splide></app-reach-out-splide>

<div class="my-5 d-flex flex-column">
  <p class="quote_3_p text-center">
    NEXT <span class="rdj_bold">&#8594;</span>
  </p>
  <h3 class="mb-3 text-center rdj_bold">ABOUT US</h3>
  <a routerLink="/who-we-are/about-us" class="know-more-btn align-self-center"
    >KNOW MORE</a
  >
</div>

<app-footer class="w-100 d-none d-sm-block"></app-footer>
<app-footer-sm class="w-100 d-sm-none"></app-footer-sm>
